export default {
    lat: 35.652832,
    lng: 139.839478,
    zoom: 15,
    minZoom: 13, // TODO implement clustering to remove the cap
    maxZoom: 20
}
